/**
 * Central registry of marketing/SEO articles.
 *
 * Single source of truth for the related-articles carousel and the footer
 * knowledge navigation. To add a new article, register it here once and add the
 * matching translation blocks (see `articleKey` and `footerKey` below).
 */
export interface MarketingArticle {
    /** Ziggy route name of the article page. */
    route: string;
    /** Key under `marketing-pages:common.relatedArticles.articles.<articleKey>` (title + description). */
    articleKey: string;
    /** Key under `translation:home.footer.navigation.<footerKey>` (footer label). */
    footerKey: string;
}

export const MARKETING_ARTICLES: MarketingArticle[] = [
    { route: 'mietkautionskonto', articleKey: 'mietkautionskonto', footerKey: 'mietkautionskonto' },
    { route: 'mietkautionskonto-vergleich', articleKey: 'vergleich', footerKey: 'vergleich' },
    { route: 'mietkautionskonto-kosten', articleKey: 'mietkautionskonto-kosten', footerKey: 'kosten' },
    { route: 'zinsen-bei-mietkautionskonten', articleKey: 'zinsen', footerKey: 'zinsen' },
    { route: 'mietkaution-rechtssicher-anlegen', articleKey: 'rechtssicher-anlegen', footerKey: 'rechtssicherAnlegen' },
    { route: 'mietkautionskonto-online-eroeffnen', articleKey: 'online-eroeffnen', footerKey: 'onlineEroeffnen' },
    { route: 'mietkautionskonto-volksbank', articleKey: 'volksbank', footerKey: 'volksbank' },
    { route: 'mietkautionskonto-ohne-girokonto', articleKey: 'ohne-girokonto', footerKey: 'ohneGirokonto' },
    { route: 'mietkaution-wer-legt-sie-an', articleKey: 'wer-legt-sie-an', footerKey: 'werLegtSieAn' },
];
